define.alias("shared/components/shared/ui/search-box/result-blank", "settings/components/shared/ui/search-box/result-blank");